import {h} from 'preact';
import {useEffect, useRef, useState} from 'preact/hooks';


const Canvas = ({core}) => {
    const canvasRef = useRef(null)
    const fps = 5
    let tabs = []
    let fpsInterval, startTime, now, then, elapsed;
    fpsInterval = 1000 / fps;
    then = Date.now();
    const draw = (ctx, frameCount) => {
        core.recorder.analyser.fftSize = 2048;
        let bufferLength = core.recorder.analyser.fftSize;
        let dataArray = new Uint8Array(bufferLength);
        core.recorder.analyser.getByteTimeDomainData(dataArray);
        ctx.fillStyle = 'rgb(43, 71, 139)';
        ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);
        ctx.lineWidth = 3;
        ctx.strokeStyle = 'rgb(256, 256, 256)';
        ctx.beginPath();
        let sliceWidth = ctx.canvas.width * 1.0 / bufferLength;
        tabs.push({max: Math.max(...dataArray), min: Math.min(...dataArray)})
        let x = ctx.canvas.width / 2;
        ctx.moveTo(ctx.canvas.width, ctx.canvas.height / 2);
        ctx.lineTo(x, ctx.canvas.height / 2);
        for (let i = tabs.length - 1; i > 0; i--) {
            const min = tabs[i].min / 128;
            const max = tabs[i].max / 128;
            ctx.lineTo(x, min * ctx.canvas.height / 2);
            x -= (sliceWidth * 5);
            ctx.lineTo(x, max * ctx.canvas.height / 2);
            x -= (sliceWidth * 5);
        }
        ctx.lineTo(x, ctx.canvas.height / 2);
        ctx.lineTo(0, ctx.canvas.height / 2);
        ctx.stroke();
    }

    useEffect(() => {

        const canvas = canvasRef.current
        canvas.width = 2000;
        canvas.height = 1000;
        const context = canvas.getContext('2d')
        let frameCount = 0
        let animationFrameId

        //Our draw came here
        const render = () => {
            frameCount++
            animationFrameId = window.requestAnimationFrame(render)
            now = Date.now();
            elapsed = now - then;
            if (elapsed > fpsInterval) {

                // Get ready for next frame by setting then=now, but...
                // Also, adjust for fpsInterval not being multiple of 16.67
                then = now - (elapsed % fpsInterval);

                if (!core.recorder.paused) {
                    draw(context, frameCount)
                }
            }
        }
        render()

        return () => {
            window.cancelAnimationFrame(animationFrameId)
        }
    }, [draw])

    return <canvas id="canvas-voice-preview" ref={canvasRef}/>
}

const OnRecordControls = ({core}) => {
    const [isPaused, setPause] = useState(false);
    const stop = () => {
        core.setView('OnEdit');
        core.recorder.stop();
    };
    const pause = () => {
        core.recorder.pause();
        setPause(true)
    };
    const resume = () => {
        core.recorder.resume();
        setPause(false)
    };

    return (
        <div className="controls">
            <button onClick={stop}>
                <img src="https://www.textfromtospeech.com/media/media/stop-light_QqbITxy.svg"
                     alt="Stop"
                />
            </button>
            {isPaused ? (
                <button onClick={resume}>
                    <img src="https://www.textfromtospeech.com/media/media/play-light_hyPPuS0.svg"
                         alt="Play"
                    />
                </button>
            ) : null}
            {!isPaused ? (
                <button onClick={pause}>
                    <img src="https://www.textfromtospeech.com/media/media/pause-light_F8pxZw9.svg"
                         alt="Pause"
                    />
                </button>
            ) : null}
        </div>
    )
}

const OnRecord = ({core}) => {
    return (
        <div className="on-record">
            <Canvas core={core}/>
            <OnRecordControls core={core}/>
        </div>
    )
}

export default OnRecord;
